// @ts-nocheck
import { CustomerAddressInput } from '~/modules/GraphQL/types';
import { CustomHeaders, CustomQuery, UseContextReturn } from '~/types/core';

export const updateCustomerAddressCommand = {
  execute: async (context: UseContextReturn, params: {
    id: number;
    input: CustomerAddressInput;
  }, customQuery: CustomQuery, customHeaders: CustomHeaders) => {
    const { data } = await context.app.$vsf.$magento.api.updateCustomerAddress(params, customQuery, customHeaders);

    return data?.updateCustomerAddress ?? {};
  },
};
